module.exports = __webpack_public_path__ + "media/assets/images/blog/potenziale_chiamate_perse-small-98a5e56b976352d75c23f8a300bfa156.png";